<div class="invite-items">
  <div class="workspace-members" *ngIf="assignedWorkspaceMembers?.length || unassignedWorkspaceMembers?.length">
    <div class="title">Workspace members</div>
    <div class="members">
      <ngx-invite-item-card *ngFor="let member of assignedWorkspaceMembers" [member]="member" [isAssign]="true" [eventId]="eventId"></ngx-invite-item-card>
      <ngx-invite-item-card *ngFor="let member of unassignedWorkspaceMembers" [member]="member" [isAssign]="false" [eventId]="eventId"></ngx-invite-item-card>
    </div>
  </div>
  <div class="invited-members" *ngIf="assignedMembers?.length">
    <div class="title">Invited members</div>
    <div class="members">
      <ngx-invite-item-card *ngFor="let member of assignedMembers" [member]="member" [isAssign]="true" [eventId]="eventId"></ngx-invite-item-card>
    </div>
  </div>
</div>
